import { CustomObject } from 'types/common'
import Api from './axiosInstance'
import { API_RMA } from 'utils/constants'

export const downloadRma = (filters: CustomObject) => {
  return Api.post({
    url: API_RMA.RMA_EXPORT,
    params: filters,
  })
}
